export default __webpack_public_path__ + "static/media/Flaticon.fa73202b.woff";